export default {
  // Header
  nav: {
    inicio: 'Inici',
    aurion: 'AURION',
    sectores: 'Sectors',
    metodo: 'Mètode',
    porQueAurion: 'Per què AURION',
    noticias: 'Notícies i mercat',
    estudioGratuito: 'Estudi gratuït',
    faqs: 'FAQs',
    contacto: 'Contacte'
  },

  // Hero
  hero: {
    titulo: 'Solucions energètiques industrials 360º',
    subtitulo: 'Enginyeria, legal i finançament integrades per reduir costos i petjada de carboni amb tecnologies renovables i sostenibles.',
    destacado1: 'Finançem, dissenyem, legalitzem i operem les teves instal·lacions energètiques.',
    destacado2: 'Només pagues un preu fix per l\'energia útil consumida, fixat des de l\'inici',
    beneficio1: 'Estalvi immediat en costos energètics i estabilitat de preu a llarg termini',
    beneficio2: 'Descarbonització de processos industrials sense CAPEX',
    beneficio3: 'Gestió integral del projecte: enginyeria, permisos, obra, ajuts i subvencions',
    ctaEstudio: 'Sol·licitar estudi gratuït',
    ctaCasos: 'Veure casos i referències'
  },

  // About Aurion
  about: {
    titulo: 'Sobre AURION',
    subtitulo: 'El teu soci estratègic en la transició energètica industrial',
    descripcion: 'AURION és una empresa especialitzada en solucions energètiques integrals per al sector industrial i agroalimentari. Combinem enginyeria d\'avantguarda, expertise legal i capacitat financera per oferir projectes clau en mà.',
    experiencia: 'Anys d\'experiència',
    proyectos: 'Projectes executats',
    mwInstalados: 'MW instal·lats',
    satisfaccion: 'Satisfacció client'
  },

  // Solutions
  solutions: {
    titulo: 'Solucions energètiques 360º per a indústria',
    subtitulo: 'Un únic interlocutor per a tot el cicle del teu projecte energètic industrial',
    ingenieria: {
      titulo: 'Enginyeria i tecnologia industrial',
      descripcion: 'Fotovoltaica per a grans consums industrials, biomassa tèrmica per a vapor i calor de procés, sistemes d\'hibridació energètica, bateries intel·ligents per a gestió de pics, digitalització i control avançat d\'instal·lacions.',
      feature1: 'Disseny tècnic adaptat a processos industrials',
      feature2: 'Integració amb sistemes existents',
      feature3: 'Optimització de rendiment energètic',
      feature4: 'Monitorització i control en temps real'
    },
    compliance: {
      titulo: 'Compliance industrial i legal',
      descripcion: 'Gestió integral de permisos i llicències industrials, due diligence regulatòria completa, contractació energètica corporativa i PPAs, alineament amb normativa ambiental i ESG.',
      feature1: 'Tramitació de permisos industrials',
      feature2: 'Auditoria regulatòria completa',
      feature3: 'Negociació de contractes energètics',
      feature4: 'Compliment normatiu garantit'
    },
    financiacion: {
      titulo: 'Finançament industrial i ajuts',
      descripcion: 'Estructures financeres corporatives CAPEX/OPEX/PPA adaptades a grans projectes, estructuració financera optimitzada, gestió de subvencions Next Generation i deduccions fiscals, reporting ESG per a inversors.',
      feature1: 'Anàlisi de viabilitat econòmica',
      feature2: 'Optimització fiscal i financera',
      feature3: 'Gestió d\'ajuts europeus',
      feature4: 'Informes ESG corporatius'
    },
    mensaje: 'Finançem, dissenyem, legalitzem i operem les teves instal·lacions energètiques.',
    mensajeDestacado: 'Tu només pagues un preu fix per l\'energia útil consumida, pactat des de l\'inici'
  },

  // Sectors
  sectors: {
    titulo: 'Sectors d\'Activitat',
    subtitulo: 'Solucions adaptades a les necessitats específiques de cada sector industrial',
    manufacturera: {
      titulo: 'Indústria Manufacturera',
      descripcion: 'Processos de fabricació, soldadura, tractaments tèrmics, aire comprimit, climatització de naus'
    },
    agroalimentaria: {
      titulo: 'Agroalimentària',
      descripcion: 'Processat d\'aliments, conservació, assecat, refrigeració, sistemes de neteja CIP'
    },
    quimica: {
      titulo: 'Química',
      descripcion: 'Processos de reacció, destil·lació, assecat, control de temperatura, tractament d\'aigües'
    },
    bebidas: {
      titulo: 'Indústria de Begudes',
      descripcion: 'Refrigeració industrial, pasteurització, CIP/SIP, embotellat i envasament'
    },
    caucho: {
      titulo: 'Indústria del Cautxú',
      descripcion: 'Vulcanització, calfament de motlles, aire comprimit, sistemes de curat'
    },
    textil: {
      titulo: 'Indústria Tèxtil',
      descripcion: 'Processos tèrmics per a tenyit, assecat i acabats, vapor industrial, climatització de naus'
    }
  },

  // Method
  method: {
    titulo: 'El Nostre Mètode',
    subtitulo: 'Un procés estructurat per garantir l\'èxit del teu projecte energètic',
    paso1: {
      titulo: 'Anàlisi',
      descripcion: 'Estudi detallat dels teus consums i necessitats energètiques'
    },
    paso2: {
      titulo: 'Disseny',
      descripcion: 'Enginyeria de solució òptima adaptada a la teva instal·lació'
    },
    paso3: {
      titulo: 'Finançament',
      descripcion: 'Estructuració financera i gestió d\'ajuts'
    },
    paso4: {
      titulo: 'Execució',
      descripcion: 'Instal·lació clau en mà amb garantia de qualitat'
    },
    paso5: {
      titulo: 'Operació',
      descripcion: 'Manteniment i optimització contínua del sistema'
    }
  },

  // Why Aurion
  whyAurion: {
    titulo: 'Per què AURION?',
    subtitulo: 'Les raons que ens diferencien al mercat de solucions energètiques industrials',
    razon1: {
      titulo: 'Solució integral 360º',
      descripcion: 'Un únic interlocutor per a enginyeria, legal i finançament'
    },
    razon2: {
      titulo: 'Sense inversió inicial',
      descripcion: 'Models OPEX i PPA que eliminen la barrera del CAPEX'
    },
    razon3: {
      titulo: 'Preu fix garantit',
      descripcion: 'Estabilitat de costos energètics a llarg termini'
    },
    razon4: {
      titulo: 'Experiència industrial',
      descripcion: 'Especialistes en projectes de gran escala i complexitat'
    },
    razon5: {
      titulo: 'Compromís ESG',
      descripcion: 'Alineació amb objectius de sostenibilitat corporativa'
    },
    razon6: {
      titulo: 'Suport continu',
      descripcion: 'Acompanyament durant tota la vida útil del projecte'
    }
  },

  // Key Metrics
  metrics: {
    titulo: 'Resultats que parlen per si sols',
    subtitulo: 'Els nostres números reflecteixen l\'impacte real de les nostres solucions',
    ahorro: 'Estalvi mitjà en factura',
    co2: 'Tones CO₂ evitades',
    proyectos: 'Projectes completats',
    satisfaccion: 'Índex de satisfacció'
  },

  // Trust Bar
  trust: {
    titulo: 'Confien en nosaltres',
    subtitulo: 'Empreses líders que han transformat el seu model energètic amb AURION'
  },

  // News
  news: {
    titulo: 'Notícies i Mercat',
    subtitulo: 'Mantén-te al dia amb les últimes novetats del sector energètic',
    leerMas: 'Llegir més',
    verTodas: 'Veure totes les notícies'
  },

  // Gallery
  gallery: {
    titulo: 'Galeria de Projectes',
    subtitulo: 'Descobreix alguns dels nostres projectes més destacats en diferents sectors i solucions energètiques'
  },

  // Main Offer / Contact Form
  offer: {
    titulo: 'Estudi gratuït d\'estalvi i petjada de carboni',
    subtitulo: 'Entreguem una anàlisi preliminar amb escenaris d\'estalvi, inversió i reducció de CO₂, sense compromís.',
    queIncluye: 'Què inclou el teu estudi',
    include1: 'Baseline de consums',
    include2: 'Mesures proposades',
    include3: 'Estimació d\'estalvis',
    include4: 'Reducció de CO₂',
    include5: 'Rang d\'inversió',
    include6: 'Ajuts aplicables',
    include7: 'Següent pas recomanat',
    entrega: 'Entrega en 5-7 dies laborables',
    entregaDesc: 'Rebràs un informe detallat amb recomanacions específiques per a la teva instal·lació',
    form: {
      provincia: 'Província',
      provinciaPlaceholder: 'La teva província',
      poblacion: 'Població',
      poblacionPlaceholder: 'La teva població',
      empresa: 'Empresa',
      empresaPlaceholder: 'Nom de la teva empresa',
      nombre: 'Nom i cognoms',
      nombrePlaceholder: 'El teu nom complet',
      cargo: 'Càrrec',
      cargoPlaceholder: 'El teu càrrec a l\'empresa',
      email: 'Email',
      emailPlaceholder: 'tu@empresa.com',
      telefono: 'Telèfon',
      telefonoPlaceholder: '+34 600 000 000',
      enviar: 'Sol·licitar estudi gratuït',
      enviando: 'Enviant...',
      exito: 'Sol·licitud enviada correctament!',
      exitoDesc: 'Rebràs el teu estudi en 5-7 dies laborables.',
      error: 'Error en enviar la sol·licitud',
      errorDesc: 'Si us plau, torna-ho a intentar o contacta amb nosaltres.',
      privacidad: 'En enviar aquest formulari acceptes la nostra política de privacitat. No compartim les teves dades amb tercers.'
    }
  },

  // Footer
  footer: {
    descripcion: 'Solucions energètiques 360º per a indústria i agroalimentari. Enginyeria, legal i finançament integrades per a la transició energètica.',
    soluciones: 'Solucions',
    sectores: 'Sectors',
    empresa: 'Empresa',
    recursos: 'Recursos',
    ingenieria: 'Enginyeria i tecnologia',
    compliance: 'Compliance i legal',
    financiacion: 'Finançament i ajuts',
    estudioGratuito: 'Estudi gratuït',
    manufacturera: 'Indústria manufacturera',
    agroalimentaria: 'Agroalimentària',
    casosExito: 'Casos d\'èxit',
    referencias: 'Referències',
    sobreAurion: 'Sobre AURION',
    metodo: 'El nostre mètode',
    equipo: 'Equip',
    contacto: 'Contacte',
    noticias: 'Notícies i mercat',
    faqs: 'FAQs',
    documentacion: 'Documentació',
    blog: 'Blog',
    derechos: 'Tots els drets reservats.',
    privacidad: 'Política de privacitat',
    terminos: 'Termes d\'ús',
    cookies: 'Cookies',
    siguenos: 'Segueix-nos:'
  },

  // Legal Pages
  legal: {
    privacidad: {
      titulo: 'Política de Privacitat',
      contenido: 'Aquesta pàgina contindrà la política de privacitat d\'AURION ENERGY S.L. Informació sobre el tractament de dades personals, drets dels usuaris i mesures de seguretat.'
    },
    terminos: {
      titulo: 'Termes d\'Ús',
      contenido: 'Aquesta pàgina contindrà els termes i condicions d\'ús del lloc web d\'AURION ENERGY S.L. Normes d\'utilització, drets i obligacions dels usuaris.'
    },
    cookies: {
      titulo: 'Política de Cookies',
      contenido: 'Aquesta pàgina contindrà la política de cookies d\'AURION ENERGY S.L. Informació sobre l\'ús de cookies, tipus de cookies utilitzades i com gestionar-les.'
    }
  }
};
